import dayjs from 'dayjs';

/** 만료일까지 남은 일수. 당일이면 0, 지났으면 음수. */
export function getGiftDday(expiredAt?: Date | string): number | null {
    if (!expiredAt) return null;
    return dayjs(expiredAt).startOf('day').diff(dayjs().startOf('day'), 'day');
}

export function formatGiftDate(value?: Date | string, pattern = 'YYYY.MM.DD'): string {
    if (!value) return '';
    return dayjs(value).format(pattern);
}

export function formatSentReceivers(names: string[], othersLabel: (count: number) => string): string {
    if (names.length === 0) return '';
    if (names.length === 1) return names[0];
    return `${names[0]} ${othersLabel(names.length - 1)}`;
}
